import * as React from "react";
import { useCallback } from "react";
import { SecurityAppSecurityEventsHistogram } from "@graylog/enterprise-api";
import EventsHistogram from "components/events/EventsHistogram";
import useUserDateTime from "hooks/useUserDateTime";
import { parseSearchParams } from "security-app/hooks/api/securityEventsAPI";
const fetchSecurityEventsHistogram = async (searchParams, timezone) => SecurityAppSecurityEventsHistogram.histogram(parseSearchParams(searchParams, timezone)).then(
  ({ effective_timerange, buckets }) => ({
    timerange: effective_timerange,
    results: { buckets }
  })
);
const SecurityEventsHistogram = ({
  searchParams,
  setFilters,
  height = void 0,
  readOnly = false,
  onEffectiveTimeRangeChange = void 0
}) => {
  const { userTimezone } = useUserDateTime();
  const _fetchSecurityEventsHistogram = useCallback(
    (_searchParams) => fetchSecurityEventsHistogram(_searchParams, userTimezone),
    [userTimezone]
  );
  return /* @__PURE__ */ React.createElement(
    EventsHistogram,
    {
      searchParams,
      setFilters,
      eventsHistogramFetcher: _fetchSecurityEventsHistogram,
      height,
      readOnly,
      onEffectiveTimeRangeChange
    }
  );
};
export default SecurityEventsHistogram;
